import Image from "components/Elements/Image/Image";

import generalStyles from "../../styles.module.scss";
import styles from "./styles.module.scss";

const NUMBER_OF_IMAGES = 3;

const CustomAnimationContol = () => {
  return (
    <div className={styles.controlImages}>
      {Array.from({ length: NUMBER_OF_IMAGES }).map((_, index) => (
        <div key={index} className={styles.element}>
          <Image
            className={`${styles.project}`}
            name={`picker/picker-prj-${index + 1}`}
            ext="png"
          />
          <Image
            className={styles.status}
            name={`picker/picker-status-${index + 1}`}
          />
        </div>
      ))}
    </div>
  );
};

export default CustomAnimationContol;
